export enum ResolutionEnum {
  DAY = 'D',
  MONTH = 'M',
}

export const ResolutionEnumDisplay = {
  [ResolutionEnum.DAY]: '按日',
  [ResolutionEnum.MONTH]: '按月',
};
